var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 110",
    style: {
      enableBackground: "new 0 0 110 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55,0C24.6242065,0,0,24.6245117,0,55c0,30.3757324,24.6242065,55,55,55c30.3756104,0,55-24.6242676,55-55 C110,24.6245117,85.3756104,0,55,0z M71.3590088,57.5166016h-13.84198v13.8419189 c0,1.3899536-1.12677,2.5167236-2.5166626,2.5167236c-1.3899536,0-2.5167236-1.12677-2.5167236-2.5167236V57.5166016h-13.84198 c-1.3899536,0-2.5167236-1.12677-2.5167236-2.5167236s1.12677-2.5167236,2.5167236-2.5167236h13.84198v-13.84198 c0-1.3899536,1.12677-2.5167236,2.5167236-2.5167236c1.3898926,0,2.5166626,1.12677,2.5166626,2.5167236v13.84198h13.84198 c1.3899536,0,2.5167236,1.12677,2.5167236,2.5167236S72.7489624,57.5166016,71.3590088,57.5166016z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWhite);
export default __webpack_public_path__ + "static/media/Plus_White.e3eb096781c1366f68dba0ec6ec0581e.svg";
export { ForwardRef as ReactComponent };